<template>
  <BaseModal no-padding name="email-subscription" :adaptive="true" :width="'100%'" :max-width="712" :height="'auto'"
             :scrollable="true" :clickToClose="false" @before-open="beforeOpen" @closed="close">
    <!-- Header -->
    <div
        class="tw-p-4 tw-min-h-4 tw-flex tw-justify-center tw-text-center tw-items-center tw-rounded-t-xl tw-font-bold tw-text-2xl tw-text-infinity-highlight tw-bg-infinity-background-emphasized-more">
      {{ emailSubscriptionHeader }}
    </div>

    <!-- Body -->
    <div class="tw-px-6 tw-py-8">
        <!-- Success Message -->
        <div v-if="subscribed" key="EnterEmailSubscriptionSuccess">
          <div
              class="tw-text-center tw-text-lg tw-py-5 tw-text-infinity-success tw-flex tw-items-center tw-justify-center">
            <font-awesome-icon :icon="['far', 'check-circle']" class="c-alert__icon"></font-awesome-icon>
            You've been subscribed!
          </div>
        </div>

        <!-- Form -->
        <form @submit.prevent="submit" v-else key="EnterEmailSubscriptionInfos">
          <div v-if="submitErrors" class="tw--ml-4 tw-text-infinity-error tw-text-base tw-font-medium">
            *Could not submit form. Please try again.
          </div>
          <div class="tw-text-center tw-text-lg tw-mb-4 tw-text-infinity-primary-text">
            {{ emailSubscriptionBody }}
          </div>
          <div class="tw-grid tw-gap-3 tw-max-w-lg tw-mx-auto">
            <base-control id="EmailSubscriptionName"
                          key="EmailSubscriptionName"
                          label="Name"
                          v-model="name"
                          size="medium"
                          type="text"
                          :triggerValidation="triggerValidation"
                          :constraints="nameConstraints"
                          @validated="onNameValidated">
            </base-control>
            <base-control id="EmailSubscriptionEmail"
                          key="EmailSubscriptionEmail"
                          label="Email"
                          v-model="email"
                          :triggerValidation="triggerValidation"
                          size="medium"
                          type="email"
                          @validated="onEmailValidated"
                          :constraints="emailConstraints">
            </base-control>
          </div>
          <div class="tw-mt-4 tw-grid tw-gap-2 tw-justify-center tw-text-center">
            <button type="submit"
                    :disabled="submitting"
                    class="c-button c-button--default tw-text-lg"
                    data-dismiss="modal">
              <font-awesome-icon v-if="submitting" class="c-button__left-icon" :icon="['far', 'spinner']" spin />
              <span>Submit</span>
            </button>
            <div class="tw-text-sm tw-cursor-pointer tw-underline tw-text-infinity-secondary-text" @click="close">
              No thanks
            </div>
          </div>
        </form>
    </div>
  </BaseModal>
</template>
<script>
import BaseModal from "../base/base-modal";
import Configure from "../../mixins/configure";

export default {
  name: "SubscriptionModal",
  components: {
    BaseModal
  },
  data() {
    return {
      name: "",
      email: "",
      subscribed: false,
      submitErrors: false,
      submitting: false,
      nameValided: false,
      emailValided: false,
      triggerValidation: false,
      autoCloseTimeout: 4000,
      isPreviewModal: false,
      isClosed: false,
      default: {
        body: "Enter your email below to join my mailing list!",
        header: "Join my mailing List"
      },
      emailConstraints: {
        presence: {
          allowEmpty: false,
          message: "Please enter your email."
        },
        email: {
          message: "Please enter a valid email."
        }
      },
      nameConstraints: {
        presence: {
          allowEmpty: false,
          message: "Please enter your name."
        }
      }
    };
  },
  mixins: [Configure],
  computed: {
    emailSubscriptionBody() {
      return this.$store.state.currentConfig?.emailSubscription.body ||this.default.body;
    },
    emailSubscriptionHeader() {
      return this.$store.state.currentConfig?.emailSubscription.header || this.default.header;
    },
    userId() {
      return ab.user.id;
    },
    emailSubscriptionTimeout() {
      return ab.config.emailSubscription.timeout * 1000; // in milliseconds;
    },
    emailSubscriptionInterval() {
      return ab.config.emailSubscription.interval || 1; // in days;
    },
    emailSubscriptionEnabled() {
      return !!ab.config.emailSubscription.enabled;
    }
  },
  mounted() {
    this.checkSubscriptionModal();
  },
  methods: {
    onNameValidated(validated) {
      this.nameValided = validated;
    },
    onEmailValidated(validated) {
      this.emailValided = validated;
    },
    submit() {
      this.triggerValidation = true;
      if (!this.nameValided || !this.emailValided) return;
      this.submitting = true;
      if(this.isPreviewModal) {
        this.submitting = false;
        this.subscribed = true;
        this.autoClose();
        return;
      }
      this.$http.post("/mailing/add", { email: this.email, name: this.name, producerId: this.userId })
          .then(_ => {
            this.subscribed = true;
            this.autoClose();
            this.submitting = false;
          })
          .catch(_ => {
            this.submitting = false;
            this.submitErrors = true;
          });
    },
    checkSubscriptionModal() {
      // 0. Check if store is eligible for email subscription
      if (!this.emailSubscriptionEnabled
          || !ab.hasMailingList
          || this.$route.name === "checkout"
          || ab.configure // Store owner
      ) {
        return;
      }

      // 2. Check if modal has been already shown
      const lastShownDate = localStorage.getItem("emailSubscriptionLastShownDate");
      if (!lastShownDate) {
        this.open();
        return;
      }

      // 3. Check if its time to show the modal again
      const today = new Date();
      const daysInterval = (today.getTime() - new Date(lastShownDate).getTime()) / (1000 * 3600 * 24);
      if (this.emailSubscriptionInterval <= daysInterval) {
        this.open();
      }
    },
    open() {
      setTimeout(() => {
        // 1. Show modal
        this.$modal.show("email-subscription");

        // 2. Save lastShownDate
        const today = new Date();
        localStorage.setItem("emailSubscriptionLastShownDate", today.toDateString());
      }, this.emailSubscriptionTimeout);
    },
    close() {
      this.$modal.hide("email-subscription");
      this.subscribed = false;
      this.name = "";
      this.email = "";
      this.triggerValidation = false;
      this.isClosed = true;
    },
    autoClose() {
      setTimeout(() => {
        if(!this.isClosed) this.close();
      }, this.autoCloseTimeout);
    },
    beforeOpen(event){
      this.isPreviewModal = event?.params?.isPreviewModal
    }
  }
};
</script>

